import { SessionService } from '@nextgen-web-framework/core';
import { MarketExtensionConfigsData } from './types/propTypes';
import MarketExtensionConfigsTypes from './types/enums';
import { Countries, DeploymentEnvironments } from 'common/types/enums';
import CombinedMarketConfigData from 'market-extensions/data.json';
import getTenantAndEnvKey from 'utils/getTenantAndEnvKey';

const getMarketExtensionsData = () => {
  const marketExtensionData = CombinedMarketConfigData as MarketExtensionConfigsData;
  return marketExtensionData[getTenantAndEnvKey() as DeploymentEnvironments];
};

const getDynamicRewrites = () => {
  const currentMarketData = getMarketExtensionsData();
  const dynamicRewritesData = { ...(currentMarketData[MarketExtensionConfigsTypes.DYNAMIC_REWRITES] ?? {}) };

  const session = SessionService.getSession();
  const currentCountry = session?.session?.currentCountry;

  if (
    currentCountry &&
    dynamicRewritesData['countryOverrides'] &&
    currentCountry in dynamicRewritesData['countryOverrides']
  ) {
    dynamicRewritesData.rewrites = {
      ...(dynamicRewritesData?.rewrites ?? []),
      ...(dynamicRewritesData['countryOverrides'][currentCountry as Countries]?.rewrites ?? []),
    };
  }

  return dynamicRewritesData;
};

const getPageConfigs = () => {
  const currentMarketData = getMarketExtensionsData();
  const pageConfigsData = { ...(currentMarketData[MarketExtensionConfigsTypes.PAGE_CONFIGS] ?? {}) };

  const session = SessionService.getSession();
  const currentCountry = session?.session?.currentCountry;

  if (currentCountry && pageConfigsData['countryOverrides'] && currentCountry in pageConfigsData['countryOverrides']) {
    pageConfigsData.pageConfigs = {
      ...(pageConfigsData?.pageConfigs ?? {}),
      ...(pageConfigsData['countryOverrides'][currentCountry as Countries]?.pageConfigs ?? {}),
    };
  }

  return pageConfigsData;
};

const getDynamicRedirects = () => {
  const currentMarketData = getMarketExtensionsData();
  const dynamicRedirectsData = { ...(currentMarketData[MarketExtensionConfigsTypes.DYNAMIC_REDIRECTS] ?? {}) };

  const session = SessionService.getSession();
  const currentCountry = session?.session?.currentCountry;

  if (
    currentCountry &&
    dynamicRedirectsData['countryOverrides'] &&
    currentCountry in dynamicRedirectsData['countryOverrides']
  ) {
    dynamicRedirectsData.redirects = {
      ...(dynamicRedirectsData?.redirects ?? []),
      ...(dynamicRedirectsData['countryOverrides'][currentCountry as Countries]?.redirects ?? []),
    };
  }

  return dynamicRedirectsData;
};

const getRedirects = () => {
  const currentMarketData = getMarketExtensionsData();
  const redirectsData = { ...(currentMarketData[MarketExtensionConfigsTypes.REDIRECTS] ?? {}) };

  const session = SessionService.getSession();
  const currentCountry = session?.session?.currentCountry;

  if (currentCountry && redirectsData['countryOverrides'] && currentCountry in redirectsData['countryOverrides']) {
    redirectsData.redirects = {
      ...(redirectsData?.redirects ?? {}),
      ...(redirectsData['countryOverrides'][currentCountry as Countries]?.redirects ?? {}),
    };
  }

  return redirectsData;
};

const getLocales = () => {
  const currentMarketData = getMarketExtensionsData();
  let localesData = { ...(currentMarketData[MarketExtensionConfigsTypes.LOCALES] ?? {}) };

  const session = SessionService.getSession();
  const currentCountry = session?.session?.currentCountry;

  if (currentCountry && localesData['countryOverrides'] && currentCountry in localesData['countryOverrides']) {
    localesData = {
      ...localesData,
      ...localesData['countryOverrides'][currentCountry as Countries],
    };
  }

  return localesData;
};

export { getDynamicRedirects, getDynamicRewrites, getLocales, getPageConfigs, getRedirects };
